<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div v-if="evaluationOptionLabel && evaluationOptionLabel.length > 0">
      評価表示：{{ evaluationOptionLabel }}
    </div>
    <div v-if="segmentLabel && segmentLabel.length > 0">
      顧客セグメント：{{ segmentLabel }}
    </div>
    <div>評価項目：{{ evaluationsLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    evaluationOption: {
      type: String,
      default: '',
    },
    customerSegment: {
      type: String,
      default: '',
    },
    evaluation: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    evaluationOptionLabel() {
      return this.$store.state.labels.evaluationOption[this.evaluationOption]
    },
    segmentLabel() {
      return this.$store.state.labels.customerSegment[this.customerSegment]
    },
    evaluationsLabel() {
      return this.$store.state.labels.evaluations[this.evaluation]
    },
  },
}
</script>
